module.exports = __webpack_public_path__ + "img/icon-x-white.ec576571.svg";